import { Component, OnInit } from '@angular/core';
import { NgxHeadroomOption } from 'ngx-headroom';
import { BehaviorSubject } from 'rxjs';
import { MobileUiService } from '../../services/mobile-ui.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  isCollapsed = true;
  options: NgxHeadroomOption;
  isMobile = new BehaviorSubject<boolean>(false);

  constructor(private mobileUiService: MobileUiService) {
    this.isMobile = this.mobileUiService.isMobile;
  }

  ngOnInit(): void {
    this.options = {
      offset: 200,
      tolerance: {
        up: 5,
        down: 0
      },
      classes: {
        initial: 'animated',
        pinned: 'slideDown',
        unpinned: 'slideOutUp'
      }
    };
  }

}
